<template>
    <div>
        <el-dialog title="添加分类" width="700px" class="icon-dialog" :visible.sync="show" @open="open"
            :before-close="closeForm" append-to-body>
            <el-form :size="size" :inline="true" :model="form" ref="form">
                <el-row>
                    <el-form-item label="题目类型：">
                        <el-select style="width: 100px;" size="small" v-model="form.type" placeholder="请选择">
                            <el-option v-for="type in type" :label="type.key" :value="type.value"
                                :key="type.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="科目类别：">
                        <el-select style="width: 100px;" size="small" v-model="form.subject" placeholder="请选择">
                            <el-option v-for="type in subject" :label="type.key" :value="type.value"
                                :key="type.value"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="分类展示：">
                        <el-select style="width: 100px;" size="small" v-model="form.is_place" placeholder="请选择">
                            <el-option v-for="type in is_place" :label="type.key" :value="type.value"
                                :key="type.value"></el-option>
                        </el-select>
                    </el-form-item>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="分类名称：" prop="classify">
                            <el-input autoComplete="off" v-model="form.classify" clearable placeholder="请输入分类名称" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <div>
                        <div>点击上传图标</div>
                        <div class="flexs">
                            <el-upload class="avatar-uploader" :action="updatehttp"
                               :headers="headers"
                                accept=".jpg, .jpeg, .png, .gif, .bmp, .JPG, .JPEG, .PBG, .GIF, .BMP"
                                :show-file-list="false" :on-success="handleAvatarSuccess"
                                :before-upload="beforeAvatarUpload">
                                <el-image v-if="form.image" class="avatar" :src="form.image"></el-image>
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </div>
                    </div>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="排序：" prop="sort">
                            <el-input autoComplete="off" v-model="form.sort" clearable placeholder="请输入排序" />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="备注：" prop="remark">
                            <el-input autoComplete="off" v-model="form.remark" clearable placeholder="请输入备注" />
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button :size="size" :loading="loading" type="primary" @click="submit">
                    <span v-if="!loading">确 定</span>
                    <span v-else>提 交 中...</span>
                </el-button>
                <el-button :size="size" @click="closeForm">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { getclassifyedit } from '../../api/userMG';

export default {
    name: 'bannerupdate',
    props: {
        show: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: 'small'
        },
        info: {
            type: Object,
        },
    },
    data() {
        return {
            updatehttp:'/problem/getImg',
            headers: {
            token: localStorage.getItem('logintoken')
            },
            cities: [],
            subject: [
                { key: '科目一', value: 0 },
                { key: '科目四', value: 3 },
            ],
            type: [
                { key: '小车', value: 0 },
                { key: '货车', value: 1 },
                { key: '客车', value: 2 },
                { key: '摩托车', value: 3 },
            ],
            is_place: [
                { key: '分类练习', value: 0 },
                { key: '精选练习', value: 1 },
                { key: '地方专题', value: 2 },
                { key: '扣12分', value: 3 },
                { key: '免费试用', value: 4 },
            ],
            form: {
                type: 0,
                is_place: 0,
                subject: 0,
                classify: '',
                image:'',
                sort:'',
                remark:''
            },
            loading: false,
            rules: {
            },
            files: '',
        }
    },
    watch:{
		show(val){
			if(val){
                console.log('1111111');
                this.form = {
                    type: 0,
                    is_place: 0,
                    subject: 0,
                    classify: '',
                    image:'',
                    sort:'',
                    remark:''
                }
			}
		}
	},
    methods: {
        handleAvatarSuccess(res, file) {
            this.form.image = res.img_url
        },
        beforeAvatarUpload(file) {
            // const isJPG = file.type === 'image/jpeg';
            // const isLt2M = file.size / 1024 / 1024 < 2;

            // if (!isJPG) {
            // this.$message.error('上传头像图片只能是 JPG 格式!');
            // }
            // if (!isLt2M) {
            // this.$message.error('上传头像图片大小不能超过 2MB!');
            // }
            // return isJPG && isLt2M;
        },
        open() {
            this.form = this.info
            this.form.pcid = this.info.pcid
            console.log(this.form,'==============');
            
        },
        submit() {
            console.log('出发了');
            
            this.$refs['form'].validate(valid => {
                if (valid) {
                    this.loading = true
                    this.form.echo = 'set'
                    getclassifyedit(this.form).then(res => {
                        if (res.code == 200) {
                            this.$message({ message: '操作成功', type: 'success' })
                            this.$emit('refesh_list')
                            this.closeForm()
                        } else {
                            this.$message({ message: '操作失败', type: 'error' })
                        }
                    }).catch(() => {
                        this.loading = false
                    })
                }
            })
        },
        closeForm() {
            this.$emit('update:show', false)
            this.loading = false
            if (this.$refs['form'] !== undefined) {
                this.$refs['form'].resetFields()
            }
        },
    }
}
</script>
<style scoped >
.flexs {
    display: flex;
    width: 500px;
    justify-content: space-between;
    margin-top: 20px;
}

.avatar-uploader .el-upload {
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    border: 1px dashed red;

}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 90px;
    height: 90px;
    line-height: 90px;
    text-align: center;
}

.avatar {
    width: 90px;
    height: 90px;
    display: block;
    border: 1px solid #E1E1E1;
}
</style>



// WEBPACK FOOTER //
// src/views/group/update.vue